import React, { createContext, useContext } from 'react';

export interface ClientBrandColors {
  accent: string;
  accentHover: string;
  accentLight: string;
  avatarBackground: string;
  avatarText: string;
}

export interface ClientBrandFonts {
  brandFont: string;
  brandFontSize: string;
  brandFontWeight: number;
  brandFontStyle: 'normal' | 'italic';
}

export interface ClientBrandConfig {
  brandName: string;
  displayName: string;
  iconText: string;
  tagline: string;
  defaultPlaceholder: string;
  siteNavButtonText: string;
  headerTitle?: string;
  welcomeMessage?: string;
  pdpWelcomeMessage?: string;
  colors: ClientBrandColors;
  fonts: ClientBrandFonts;
  iconSvgPaths: string[];
  iconViewBox: string;
  suggestions: string[];
  homeChips: string[];
  featuredChips?: string[];
  collectionSuggestions: Record<string, string[]>;
  cartChips?: string[];
  cartSuggestions?: string[];
  currency: string;
  locale: string;
  modelBaseImages?: Record<string, string[]>;
  features: {
    showSizeHelp: boolean;
    showBodyShapeSelector: boolean;
    showSizeChart: boolean;
    showSizeRecommendation: boolean;
    photoAction: 'virtualTryOn' | 'skinAnalysis' | 'arPreview' | 'none';
  };
  labels: {
    colorTerm: string;
    materialTerm: string;
    sizeTerm: string;
    bundleTerm: string;
  };
  personalizedPDP?: {
    cardTitle?: string;
  };
}

const BrandConfigContext = createContext<ClientBrandConfig | null>(null);

export function useBrandConfig(): ClientBrandConfig {
  const ctx = useContext(BrandConfigContext);
  if (!ctx) {
    throw new Error('useBrandConfig must be used within a BrandConfigProvider');
  }
  return ctx;
}

export function BrandConfigProvider({
  config,
  children,
}: {
  config: ClientBrandConfig;
  children: React.ReactNode;
}) {
  return (
    <BrandConfigContext.Provider value={config}>
      {children}
    </BrandConfigContext.Provider>
  );
}
